import { useEffect } from "react";

// Aviso flotante de confirmación (p. ej. "canción agregada"): se muestra en la esquina
// y se cierra solo después de `duracion` milisegundos para no tapar la pantalla.
function AvisoFlotante({ mensaje, onCerrar, duracion = 3000 }) {
  useEffect(() => {
    if (!mensaje) return undefined;
    const cierre = setTimeout(onCerrar, duracion);
    return () => clearTimeout(cierre);
  }, [mensaje, onCerrar, duracion]);

  if (!mensaje) return null;
  return (
    <div role="status" className="animate-deslizar fixed bottom-5 right-5 z-[80] max-w-sm rounded-2xl border border-emerald-500/40 bg-zinc-950/95 px-4 py-3 text-sm text-white shadow-2xl backdrop-blur">
      {mensaje}
    </div>
  );
}

export default AvisoFlotante;
